import React, { useState, forwardRef, useContext, useEffect, useImperativeHandle} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import classNames from 'classnames';
import { Theme } from '../contexts/themeContext.js';
import {Typography, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import LensIcon from '@material-ui/icons/Lens';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import { TransactionTime } from '../common/transactionTime';

const useStyles = makeStyles(theme => ({
    colorBlue: {
        color:'blue'
    },
    colorGreen: {
        color: 'green'
    },
    colorOrange: {
        color: 'orange'
    },
    colorPurple: {
        color: 'purple'
    },
    listItemIcon: {
        minWidth: '20px'
    },
    lensIcon: {
        width: '10px'
    },
}));

const FoodTrayChecklist = forwardRef((props, ref) => {
    const classes = useStyles();
    const {  patientSittingDto,close } = props;
    const { theme } = useContext(Theme);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);
    const [ftChecklist, setftChecklist] = useState([
        { OptionId: 1, Completed: null, Title: "Patient Identification", Activity:"Verify that name on the tray matches patient",TimeCompleted:null,Comments:"" },
        { OptionId: 2, Completed: null, Title: "Food Tray Item Entering Check", Activity:"Count the number of items on food tray and place in comment section",TimeCompleted:null,Comments:"" },
        { OptionId: 3, Completed: null, Title: "Utensils Check", Activity:"Verify that the proper utensils are on the tray. Remove metal utensils for SI patients and replace with paper utensils.",TimeCompleted:null,Comments:"" },
        { OptionId: 4, Completed: null, Title: "Food Packing Check", Activity:"Remove all food packages that are potential hazards such as plastic wraps, bottle caps, bottles, etc.",TimeCompleted:null,Comments:"" },
        { OptionId: 5, Completed: null, Title: "Dietary Restrictions", Activity: "Verify patients’ diet and confirm that food items comply with patient’s dietary restrictions. (See Dietary Descriptions Below)", TimeCompleted: null, Comments: "" },
        { OptionId: 6, Completed: null, Title: "Dietary Allergens", Activity: "Verify that all food items comply with patient’s allergies if any (See List of Allergens Below)", TimeCompleted: null, Comments: "" },
        { OptionId: 7, Completed: null, Title: "Food Tray Access", Activity: "Position Food Tray within reach of patient after the above items are completed and assist with opening containers.", TimeCompleted: null, Comments: "" },
        { OptionId: 8, Completed: null, Title: "Food Tray Item Exit Check", Activity: "Count the number of items on food tray and place in comment section", TimeCompleted: null, Comments: "" },
    ]);

    const onCompletedChecked = (item, e) => {
        let list = [...ftChecklist];
        list.forEach(l => {
            if (l.OptionId === item.OptionId) {
                l.Completed = e.target.value;
            }
        });
        setftChecklist(list);
    }

    const onCompletedDateTimeChanged = (item, date) => {
        let list = [...ftChecklist];
        list.forEach(l => {
            if (l.OptionId === item.OptionId) {
                l.TimeCompleted = moment(date).format("MM/DD/YYYY hh:mm a");;
            }
        });
        setftChecklist(list);
    }

    const onCommentsChange = (item,e) => {
        let list = [...ftChecklist];
        list.forEach(l => {
            if (l.OptionId === item.OptionId) {
                l.Comments = e.target.value;
            }
        });
        setftChecklist(list);
    }

    const converToNumber = (val) => {
        return Number(val);
    }

    const saveFoodTrayChecklist = () => {

        let _patientFellDto = {
            AppPatientSittingId: patientSittingDto.Id,
            POSFoodTrayChecklistItems: ftChecklist
        }
        TransactionTime.end();
        TransactionTime.updateData(_patientFellDto);

        HttpService.post('/PatientSitting/SaveFoodTrayChecklist',
            _patientFellDto
        )
        .then((result) => {
            TransactionTime.cancel();
            close();
        });
    }

    const getFoodTrayChecklist = () => {
        HttpService.post('/PatientSitting/GetFoodTrayChecklist',
            {
                AppPatientSittingId: patientSittingDto.Id
            }
        )
            .then((result) => {
                let dto = result.data;
                if (dto.POSFoodTrayChecklistItems.length > 0) {
                    let list = [...ftChecklist];
                    list.forEach(l => {
                        let item = dto.POSFoodTrayChecklistItems.find(x => x.Title === l.Title);
                        l.Completed = item.Completed;
                        l.TimeCompleted = item.TimeCompleted;
                        l.Comments = item.Comments;
                    });
                    setftChecklist(list);
                }
        });
    }

    const declineFoodTrayChecklist = function () {
        TransactionTime.cancel();
    };

    useImperativeHandle(ref, () => {
        return {
            save: saveFoodTrayChecklist,
            cancel: declineFoodTrayChecklist
        };
    });

    useEffect(() => {
        getFoodTrayChecklist();
        TransactionTime.begin('startFoodTrayChecklist');
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <table className="table table-bordered">
                <thead className="thead-light">
                    <tr>
                        <th scope="col">Monitor/ Assist With</th>
                        <th scope="col">Activity</th>
                        <th scope="col" width="170">Completed (Yes/No)</th>
                        <th scope="col" width="265">Time Completed</th>
                        <th scope="col" width="251">Comments</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ftChecklist.map((item,index) => {
                            return (
                                <tr key={"item"+index }>
                                    <th className={classes.colorBlue} scope="col">{ item.Title}</th>
                                    <th>{item.Activity}</th>
                                    <th>
                                        <RadioGroup
                                            aria-label="position"
                                            name={"completed" + item.OptionId}
                                            value={item.Completed}
                                            onChange={(e) => { onCompletedChecked(item,e) }}
                                            row
                                        >
                                            <FormControlLabel
                                                value="Yes"
                                                control={<Radio style={{ color: currentTheme.secondary }} />}
                                                label="Yes"
                                                labelPlacement="end"
                                                style={{ color: currentTheme.text }}
                                            />
                                            <FormControlLabel
                                                value="No"
                                                control={<Radio style={{ color: currentTheme.secondary }} />}
                                                label="No"
                                                labelPlacement="end"
                                                style={{ color: currentTheme.text }}
                                            />
                                        </RadioGroup>
                                    </th>
                                    <th>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker fullWidth hideTabs autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                id={"CompletedDateTime"+item.Id}
                                                format="MM/dd/yyyy hh:mm a"
                                                size="small"
                                                value={item.TimeCompleted}
                                                onChange={date => onCompletedDateTimeChanged(item,date)}
                                                InputAdornmentProps={{ position: "start" }}
                                                PopoverProps={{
                                                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                    transformOrigin: { horizontal: "left", vertical: "top" }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </th>
                                    <th>
                                        {
                                            item.OptionId !== 2 && item.OptionId !== 8 &&
                                            <TextField
                                                id="standard-name"
                                                className={classes.textField}
                                                value={item.Comments}
                                                onChange={(e) => { onCommentsChange(item,e) }}
                                                margin="normal"
                                            />
                                        }
                                        {
                                            item.OptionId === 2 &&
                                            <TextField
                                                id="standard-number"
                                                label="Number of Items Entering"
                                                value={converToNumber(item.Comments)}
                                                onChange={(e) => { onCommentsChange(item, e) }}
                                                type="number"
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                            />
                                        }
                                        {
                                            item.OptionId === 8 &&
                                            <TextField
                                                id="standard-number"
                                                label="Number of Items Exiting"
                                                value={converToNumber(item.Comments)}
                                                onChange={(e) => { onCommentsChange(item, e) }}
                                                type="number"
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                            />
                                        }
                                    </th>
                                </tr>
                            )
                        })
                    }
                   
                </tbody>
                
            </table>
            <br />
            <br />
            <Typography ariant="title">
                <strong className={classes.colorGreen}>Diets:</strong>
            </Typography>
            <br />
            <br />
            <Typography ariant="title">
                <strong>Clear liquid diet – </strong> Includes minimum residue fluids that can be seen through
            </Typography>
            <List>
                <ListItem >
                    <ListItemIcon className={classes.listItemIcon} >
                        <LensIcon className={classNames(classes.lensIcon)}  />
                    </ListItemIcon>
                    <ListItemText
                        primary="Examples are juices without pulp, broth, and Jell-O."
                    />
                </ListItem>
            </List>

            <Typography ariant="title">
                <strong>Full liquid diet – </strong> Includes fluids that are creamy.
            </Typography>
            <List>
                <ListItem >
                    <ListItemIcon className={classes.listItemIcon} >
                        <LensIcon className={classNames(classes.lensIcon)} />
                    </ListItemIcon>
                    <ListItemText
                        primary="Examples of food allowed are ice cream, pudding, thinned hot cereal, custard, strained cream soups, and juices with pulp."
                    />
                </ListItem>
            </List>
            <br />

            <Typography ariant="title">
                <strong>No Concentrated Sweets (NCS) diet – </strong> Is considered a liberalized diet for diabetics when their weight and blood sugar levels are under control. It includes regular foods without the addition of <strong>sugar</strong>.
            </Typography>
            <br />

            <Typography ariant="title">
                <strong>Diabetic or calorie-controlled diet (ADA) – </strong> These diets control calories, carbohydrates, protein, and fat intake in balanced amounts to meet nutritional needs, control blood sugar levels, and control weight.
            </Typography>
            <br />

            <Typography ariant="title">
                <strong>No Added Salt (NAS) diet – </strong> Is a regular diet with no salt packet on the tray. Food is seasoned as regular food.
            </Typography>
            <br />

            <Typography ariant="title">
                <strong>Low Sodium (LS) diet – </strong> May also be called a 2 gram Sodium Diet.
            </Typography>
            <List>
                <ListItem >
                    <ListItemIcon className={classes.listItemIcon} >
                        <LensIcon className={classNames(classes.lensIcon)} />
                    </ListItemIcon>
                    <ListItemText
                        primary="Examples - Limits salt and salty foods such as bacon, sausage, cured meats, canned soups, salty seasonings, pickled foods, salted crackers, etc."
                    />
                </ListItem>
            </List>
            <br />

            <Typography ariant="title">
                <strong>Low fat/low cholesterol diet – </strong> Is used to reduce fat levels and/or treat medical conditions that interfere with how the body uses fat such as diseases of the liver, gallbladder, or pancreas.
            </Typography>
            <br />

            <Typography ariant="title">
                <strong>High fiber diet – </strong> Is prescribed in the prevention or treatment of a number of gastrointestinal, cardiovascular, and metabolic diseases.
            </Typography>
            <List>
                <ListItem >
                    <ListItemIcon className={classes.listItemIcon} >
                        <LensIcon className={classNames(classes.lensIcon)} />
                    </ListItemIcon>
                    <ListItemText
                        primary="Examples - Increased fiber should come from a variety of sources including fruits, legumes, vegetables, whole breads, and cereals."
                    />
                </ListItem>
            </List>
            <br />

            <Typography ariant="title">
                <strong>Renal diet – </strong> Is for renal/kidney people. The diet plan is individualized depending on if the person is on dialysis. The diet restricts sodium, potassium, fluid, and protein specified levels.
            </Typography>
            <br />

            <Typography ariant="title">
                <strong>Mechanically altered or soft diet – </strong> Is used when there are problems with chewing and swallowing. Changes the consistency of the regular diet to a softer texture. Includes chopped or ground meats as well as chopped or ground raw fruits and vegetables. Is for people with poor dental conditions, missing teeth, no teeth, or a condition known as dysphasia.
            </Typography>
            <br />

            <Typography ariant="title">
                <strong>Pureed diet – </strong> Changes the regular diet by pureeing it to a smooth liquid consistency. Is for people with chewing or swallowing difficulties or with the condition of dysphasia.
            </Typography>
            <List>
                <ListItem >
                    <ListItemIcon className={classes.listItemIcon} >
                        <LensIcon className={classNames(classes.lensIcon)} />
                    </ListItemIcon>
                    <ListItemText
                        primary="Examples - Avoid nuts, seeds, raw vegetables, and raw fruits."
                    />
                </ListItem>
            </List>
            <br />

            <Typography ariant="title">
                <strong>Food allergy modification – </strong> Food allergies are due to an abnormal immune response to an otherwise harmless food. Foods implicated with allergies are strictly eliminated from the diet.
            </Typography>
            <List>
                <ListItem >
                    <ListItemIcon className={classes.listItemIcon} >
                        <LensIcon className={classNames(classes.lensIcon)} />
                    </ListItemIcon>
                    <ListItemText
                        primary="Example - The most common food allergens are milk, egg, soy, wheat, peanuts, tree nuts, fish, and shellfish. Additionally, a gluten free diet would include the elimination of wheat, rye, and barley. Replaced with potato, corn, and rice products."
                    />
                </ListItem>
            </List>
            <br />

            <Typography ariant="title">
                <strong className={classes.colorOrange}>Food Allergens:</strong>
            </Typography>
            <List>
                <ListItem >
                    <ListItemIcon className={classes.listItemIcon} >
                        <LensIcon className={classNames(classes.lensIcon)} />
                    </ListItemIcon>
                    <ListItemText
                        primary="The most common food intolerance is intolerance to lactose (milk sugar) because of a decreased amount of an enzyme in the body."
                    />
                </ListItem>
                <ListItem >
                    <ListItemIcon className={classes.listItemIcon} >
                        <LensIcon className={classNames(classes.lensIcon)} />
                    </ListItemIcon>
                    <ListItemText
                        primary="Other common types of food intolerance include adverse reactions to certain products added to food to enhance taste, color, or protect against bacterial growth."
                    />
                </ListItem>
            </List>
            <br />

            <Typography ariant="title">
                <strong className={classes.colorPurple}>Tube feedings:</strong>
            </Typography>
            <List>
                <ListItem >
                    <ListItemIcon className={classes.listItemIcon} >
                        <LensIcon className={classNames(classes.lensIcon)} />
                    </ListItemIcon>
                    <ListItemText
                        primary="Tube feedings are used for people who cannot take adequate food or fluids by mouth."
                    />
                </ListItem>
                <ListItem >
                    <ListItemIcon className={classes.listItemIcon} >
                        <LensIcon className={classNames(classes.lensIcon)} />
                    </ListItemIcon>
                    <ListItemText
                        primary="All or parts of nutritional needs are met through tube feedings."
                    />
                </ListItem>
                <ListItem >
                    <ListItemIcon className={classes.listItemIcon} >
                        <LensIcon className={classNames(classes.lensIcon)} />
                    </ListItemIcon>
                    <ListItemText
                        primary="Some people may receive food by mouth if they can swallow safely and are working to be weaned off the tube feeding."
                    />
                </ListItem>
            </List>
        </div>
    );
});
export default FoodTrayChecklist;